import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errMsg } from "@/lib/api";

const short = (o) => (o && Object.keys(o).length ? JSON.stringify(o).slice(0, 160) : "—");

export default function AdminAudit() {
  const [f, setF] = useState({ admin_email: "", action: "", record_type: "", business_id: "", date_from: "", date_to: "" });
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ rows: [], total: 0, pages: 1 });
  const [df, setDf] = useState(f);
  useEffect(() => {
    const t = setTimeout(() => setDf(f), 300);
    return () => clearTimeout(t);
  }, [f]);
  useEffect(() => {
    const c = new AbortController();
    adminApi
      .get("/audit", { params: { ...df, page }, signal: c.signal })
      .then((r) => setData(r.data))
      .catch((e) => !c.signal.aborted && toast.error(errMsg(e)));
    return () => c.abort();
  }, [df, page]);
  const inp = (k, ph, type = "text") => (
    <input type={type} value={f[k]} placeholder={ph} onChange={(e) => { setF({ ...f, [k]: e.target.value }); setPage(1); }} data-testid={`audit-filter-${k}`} className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm" />
  );
  return (
    <div className="space-y-4" data-testid="admin-audit">
      <div className="flex flex-wrap gap-2">
        {inp("admin_email", "Admin email")}{inp("action", "Action (edit, delete…)")}{inp("record_type", "Record type")}{inp("business_id", "Business id")}{inp("date_from", "", "date")}{inp("date_to", "", "date")}
        <span className="ml-auto self-center font-mono text-xs text-slate-500" data-testid="audit-total">{data.total} entries · read-only</span>
      </div>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="w-full min-w-[900px] text-left text-sm" data-testid="audit-table">
          <thead className="bg-slate-50 font-mono text-[10.5px] uppercase tracking-wider text-slate-500"><tr><th className="px-3 py-2">Time</th><th className="px-3 py-2">Admin</th><th className="px-3 py-2">Action</th><th className="px-3 py-2">Record</th><th className="px-3 py-2">Business</th><th className="px-3 py-2">Old</th><th className="px-3 py-2">New</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {data.rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                <td className="whitespace-nowrap px-3 py-2 font-mono text-xs">{r.at.slice(0, 19).replace("T", " ")}</td>
                <td className="px-3 py-2">{r.admin_email || r.admin_id}</td>
                <td className="px-3 py-2 font-semibold" data-testid={`audit-action-${r.id}`}>{r.action}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.record_type}{r.record_id ? ` · ${r.record_id}` : ""}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.business_id || "—"}</td>
                <td className="max-w-[220px] break-all px-3 py-2 font-mono text-[11px] text-slate-500">{short(r.old)}</td>
                <td className="max-w-[220px] break-all px-3 py-2 font-mono text-[11px] text-slate-700">{short(r.new)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-2 text-sm">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)} className="h-9 rounded-lg border border-slate-200 bg-white px-3 disabled:opacity-40" data-testid="audit-prev">Prev</button>
        <span className="font-mono text-xs">{page} / {data.pages}</span>
        <button disabled={page >= data.pages} onClick={() => setPage(page + 1)} className="h-9 rounded-lg border border-slate-200 bg-white px-3 disabled:opacity-40" data-testid="audit-next">Next</button>
      </div>
    </div>
  );
}
